import axios from 'axios'; // https://designrevision.com/react-axios/
import axiosRetry from 'axios-retry';
import config from '~/config';
import Cookies from 'js-cookie';
import _ from 'lodash';
import userEvent from '@testing-library/user-event';

const _api = axios.create({
  baseURL: config.strapiAPI.URL,
  responseType: 'json'
})

enum Keys {
  apiToken = 'content_jwt',
  userToken = 'user_jwt'
}

const axiosRetryOptions = {
  retries: 2,
  retryDelay: (retryCount) => {
    return retryCount * 100;
  },
}

export const apiController = {
  setAPIToken: (token, expiresInSeconds) => {
    Cookies.set(Keys.apiToken, 
      token, {
        // expires accepts value in days 
        expires: expiresInSeconds / 24 / 60 / 60 
    });
  },

  getAPIToken: () => {
    return Cookies.get(Keys.apiToken);
  },

  clearAPIToken: () => {
    Cookies.remove(Keys.apiToken);
  },

  loadAPIToken: async () => {
    return new Promise((resolve, reject) => {
      axiosRetry(_api, axiosRetryOptions);
      _api.post('/auth/local', {
        identifier: 'api_consumer',
        password: '200Vallejo!'
      }).then((res) => {
        if (res.data.jwt) {
          apiController.setAPIToken(res.data.jwt, 240000);
          resolve(apiController.getAPIToken);
          if (config.debug) { console.log('content api_consumer /auth/local returned', res); }
        } else {
          reject('');
        }
      }).catch((err) => {
        reject(err);
      })
    })
  },

  setUserToken: (token, expiresInSeconds) => {
    Cookies.set(Keys.userToken, 
      token, {
        // expires accepts value in days 
        expires: expiresInSeconds / 24 / 60 / 60 
    });
  },

  getUserToken: () => {
    return Cookies.get(Keys.userToken);
  },

  clearUserToken: () => {
    Cookies.remove(Keys.userToken);
  },

  getContentURL: () => {
    return config.strapiAPI.URL;
  },

  // TODO: refresh admin token if stale
  findUsers: async (uid: string) => {
    return new Promise((resolve, reject) => {
      axiosRetry(_api, axiosRetryOptions);
      _api.get(
        '/users',
        {
          params: { uid },
          headers: {
            'Authorization': 'Bearer ' + apiController.getAPIToken()
          }
        }
      ).then((res) => {
        if (res.data) {
          resolve(res.data);
        } else {
          reject([]);
        }
      }).catch((err) => {
        reject(err);
      });
    })
  },

  // TODO: refresh admin token if stale
  loadResources: async () => {
    return new Promise((resolve, reject) => {
      axiosRetry(_api, axiosRetryOptions);
      _api.get(
        '/resources',
        {
          headers: {
            'Authorization': 'Bearer ' + apiController.getAPIToken()
          }
        }
      ).then((res) => {
        if (res.data) {
          resolve(res.data);
        } else {
          reject([]);
        }
      }).catch((err) => {
        reject(err);
      });

    })
  },

  createUser: async (user) => {
    return new Promise((resolve, reject) => {
      axiosRetry(_api, axiosRetryOptions);
      _api.post(
        '/users',
       user,
        {
          headers: {
            'Authorization': 'Bearer ' + apiController.getAPIToken()
          }
        }
      ).then((res) => {
        if (res.data) {
          resolve(res.data);
        } else {
          reject([]);
        }
      }).catch((err) => {
        reject(err);
      });
    })
  },

  addFavoriteResource: async (favoriteResources, resource, userContentID) => {
    return new Promise((resolve, reject) => {
      axiosRetry(_api, axiosRetryOptions);
      let newResources = favoriteResources;
    
      newResources = [...newResources, resource];

      _api.put(
        '/users/' + userContentID,
        {
          'favorited_resources': newResources
        },
        {
          headers: {
            'Authorization': 'Bearer ' + apiController.getAPIToken()
          }
        }
      ).then((res) => {
        if (res.data) {
          resolve(res.data);
        } else {
          reject([]);
        }
      }).catch((err) => {
        reject(err);
      });

    })
  },

  removeFavoriteResource: async (favoriteResources, resource, userContentID) => {
    return new Promise((resolve, reject) => {
      axiosRetry(_api, axiosRetryOptions);
      let newResources = favoriteResources;
    
      newResources = _.filter(newResources, function(r) { return r.id !== resource.id});

      _api.put(
        '/users/' + userContentID,
        {
          'favorited_resources': newResources
        },
        {
          headers: {
            'Authorization': 'Bearer ' + apiController.getAPIToken()
          }
        }
      ).then((res) => {
        if (res.data) {
          resolve(res.data);
        } else {
          reject([]);
        }
      }).catch((err) => {
        reject(err);
      });

    })
  },


}

export default apiController;


// WEBPACK FOOTER //
// ./src/utils/contentAPI.ts